import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import MatrizSucesionServices from "./MatrizSucesion.service";
import { clearEmployees} from "../../employees/actions";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getMatrizSucesion = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_MATRIZ_SUCESION,
      payload: true,
    });
    const resp = await MatrizSucesionServices.getMatrizSucesion(filters);

    dispatch({
      type: actions.GET_MATRIZ_SUCESION,
      payload: {
        matrizSucesion: resp.data.data,
        matrizSucesionLength: resp.data.count
      },

    });
    dispatch({
      type: actions.MATRIZ_SUCESION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.MATRIZ_SUCESION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_MATRIZ_SUCESION,
      payload: false,
    });
  }
};


export const saveSucesorMatrizSucesion =
  (data, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_MATRIZ_SUCESION,
        payload: true,
      });
      const resp = await MatrizSucesionServices.saveSucesor(data);
      const { matrizSucesion, matrizSucesionLength } = getState().matrizSucesion;
      const _matrizSucesion = matrizSucesion
      _matrizSucesion[index] = resp.data[0]
      dispatch({
        type: actions.GET_MATRIZ_SUCESION,
        payload: {
          matrizSucesion: _matrizSucesion,
          matrizSucesionLength: matrizSucesionLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_MATRIZ_SUCESION,
        payload: false,
      });
      dispatch(clearEmployees())
    }
  };

export const deleteSucesorMatrizSucesion = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_MATRIZ_SUCESION,
      payload: true,
    });
    debugger
    const resp = await MatrizSucesionServices.deleteSucesor(id);
    const { matrizSucesion, matrizSucesionLength } = getState().matrizSucesion;
    const _matrizSucesion = matrizSucesion
    _matrizSucesion[index] = resp.data[0]
    dispatch({
      type: actions.GET_MATRIZ_SUCESION,
      payload: {
        matrizSucesion: matrizSucesion,
        matrizSucesionLength: matrizSucesionLength,
      },
    });
    dispatch({
      type: actions.MATRIZ_SUCESION_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.MATRIZ_SUCESION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_MATRIZ_SUCESION,
      payload: false,
    });
  }
};